import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import DefaultCodes from '../views/DefaultCodesPage.vue'
import DefaultCodesList from '../views/DefaultCodesListPage.vue'
import DownloadIVPage from '../views/DownloadIVPage.vue'
import ExternSoftwaresPage from '../views/ExternSoftwaresPage.vue'
import FAQPage from '../views/FAQPage.vue'
import NoFoundPage from '../views/NoFoundPage.vue'
import IVShowCasePage from '../views/IVShowCasePage.vue'
import UserManualPage from '@/views/UserManualPage.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  // UTILS
  {
    path: '/download-iv',
    name: 'DownloadIVMenu',
    component: HomePage,
    //meta: { parent: 'utilsService', self: 'DownloadIVMenu' },
    beforeEnter(to, from, next) {
      window.location.href = "https://manitou.app.documoto.com/ui/microsite/1101269";
    }
  },
  {
    path: '/extern-softwares',
    name: 'ThirdPartySoftwareMenu',
    component: HomePage,
    //meta: { parent: 'utilsService' },
    beforeEnter(to, from, next) {
      window.location.href = "https://manitou.app.documoto.com/ui/microsite/1113822";
    }
  },
  {
    path: '/iv-showcase',
    name: 'IVPresentation',
    component: IVShowCasePage,
    meta: { parent: 'utilsService' }
  },
  // UNDERSTAND MACHINE
  {
    path: '/default-codes',
    name: 'FaultCodesMenu',
    component: HomePage,
    //meta: { parent: 'understandMachine' },
    beforeEnter(to, from, next) {
      window.location.href = "https://manitou.app.documoto.com/ui/microsite/1122768";
    }
  },
  // HELP
  {
    path: '/faq',
    name: 'FAQMenu',
    component: HomePage,
    //meta: { parent: 'HelpMenu' }
    beforeEnter(to, from, next) {
      window.location.href = "https://manitou.app.documoto.com/ui/microsite/1127762";
    }
  },
  {
    path: '/:catchAll(.*)',
    component: NoFoundPage
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router
